import { axiosInstance } from '../utils/axiosInstance';

export const enum EVENT_TYPES {
  PAGE_OPEN = 'pageOpen',
  FORM_FILLED = 'formFilled',
  START_INTERVIEW = 'startInterview',
  SHOW_MORE = 'showMore',
  SHOW_LESS = 'showLess',
  DOCUMENT_UPLOADED = 'documentUploaded',
  TOP_TIPS_CLICKED = 'topTipsClicked',
  TOP_TIPS_LIKED = 'topTipsLiked',
  TOP_TIPS_DISLIKED = 'topTipsDisliked',
  INTRO_VIDEO_PLAYED = 'introVideoPlayed',
  OPEN_WIDGET = 'openWidget',
  WELCOME_STATE_START_BUTTON = 'welcomeStateStartButton',
  WELCOME_STATE_TOP_TIPS = 'welcomeStateTopTips',
  WELCOME_STATE_VIDEO_FULLY_WATCHED = 'welcomeStateVideoFullyWatched',
  PERMISSION_DENIED = 'permissionsDenied',
  PERMISSION_GRANTED = 'permissionsGranted',
  CAMRTA_INITIALIZED = 'cameraInitialized',
  MIC_INITIALIZED = 'micInitialized',
  BANDWIDTH_CHECK = 'bandwidthCheck',
  VIDEO_QUESTION_WATCHED = 'videoQuestionWatched',
  VIDEO_QUESTION_PLAY = 'videoQuestionPlay',
  VIDEO_QUESTION_PAUSE = 'videoQuestionPause',
  PRACTICE_CLICKED = 'practiceClicked',
  PRACTICE_STARTED = 'practiceStarted',
  PRACTICE_ENDED = 'practiceEnded',
  PRACTICE_FINISHED = 'practiceFinished',
  PRACTICE_SKIPPED = 'practiceSkipped',
  START_CLICKED = 'startClicked',
  MINIMIZE_WIDGET = 'minimizeWidget',
  QUESTION_STARTED = 'questionStarted',
  QUESTION_ENDED = 'questionEnded',
  RETAKE_CLICKED = 'retakeClicked',
  NO_SOUND = 'noSound',
  CAMERA_CHANGED = 'cameraChanged',
  MICROPHONE_CHANGED = 'microphoneChanged',
  SOUND_RESTORED = 'soundRestored',
  TIMES_UP = 'timesUp',
  COMPLETED_INTERVIEW = 'completedInterview',
  PAGE_CLOSED = 'pageClosed',
}

export type IEventType = `${EVENT_TYPES}`;

export interface ITrackEvent {
  eventType: IEventType;
  extraData?: any;
}

let event_id: string | undefined;
export const getEventId = () => event_id;

export const updateEventId = (eventId: typeof event_id):void => { event_id = eventId; };

const jsonBlobEventConvertor = (data: ITrackEvent) => new Blob([JSON.stringify([data])], { type: 'application/json' });

export const emitTrackEvent = (eventData: ITrackEvent):void => {
  if (!event_id) return;
  if ('sendBeacon' in navigator) {
    const blob = jsonBlobEventConvertor(eventData);
    navigator.sendBeacon(`${axiosInstance.defaults.baseURL}/applications/event/${event_id}`, blob);
  } else {
    axiosInstance.post(`/applications/event/${event_id}`, eventData);
  }
};

window.onbeforeunload = () => {
  if ('sendBeacon' in navigator) {
    const blob = jsonBlobEventConvertor({ eventType: EVENT_TYPES.PAGE_CLOSED });
    navigator.sendBeacon(`${axiosInstance.defaults.baseURL}/applications/event/${event_id}`, blob);
  }
};
